import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const tlmDeleteApi = createAsyncThunk(
  "auth/tlm/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.learningMaterialAction(`${id}`, 1));
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const tlmDeleteSlice = createSlice({
  name: "tlm delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(tlmDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(tlmDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(tlmDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const tlmDeleteReducer = tlmDeleteSlice.reducer;
